import { useRef } from 'react';
import '../styles/Input.css';
import { shouldRenderAutoRequiredMark } from '../utils/requiredLabel';

const PhoneNumberInput = ({ 
  label, 
  placeholder = "923XXXXXXXXX", 
  name, 
  value, 
  onChange, 
  onBlur,
  error, 
  touched, 
  disabled = false, 
  className = '', 
  required = true, 
  setFieldValue 
}) => {

  const inputRef = useRef(null);
  const shouldShowAutoRequired = shouldRenderAutoRequiredMark(label, required);

  const handleChange = (e) => {
    let inputValue = String(e.target.value ?? "").replace(/\D/g, "");

    if (inputValue.length > 12) {
      inputValue = inputValue.slice(0, 12);
    }

    if (setFieldValue) {
      setFieldValue(name, inputValue);
    } else if (onChange) {
      e.target.value = inputValue;
      onChange(e);
    }
  };

  return (
    <div className={`input_wrapper ${className}`} data-field-name={name}>
      <div
        className={`input_container ${disabled ? 'disabled' : ''}`}
        style={{ position: 'relative' }}
      >
        <label style={{ display: "flex", gap: "5px" }}>
          {label} {shouldShowAutoRequired && <span style={{ color: "red", fontSize: "13px" }}>*</span>}
        </label>
        
        <input
          ref={inputRef}
          type="tel"
          name={name}
          value={value}
          onChange={handleChange}
          onBlur={onBlur}
          placeholder={placeholder}
          disabled={disabled}
          className={`${disabled ? 'disabled-component' : ''}`}
          maxLength={12}
        />
      </div>
      {(() => {
        const isRequiredError = typeof error === 'string' && error.toLowerCase().includes('required');
        const hasValue = value !== null && value !== undefined && String(value).trim().length > 0;
        const shouldShowError = touched && error && (!hasValue || !isRequiredError);

        return shouldShowError ? (
          <div className="error-message" style={{ color: '#ff0000de', fontSize: '12px', marginTop: "3px", marginLeft: "5px" }}>
            {error}
          </div>
        ) : null;
      })()}
    </div>
  )
}

export default PhoneNumberInput;
